 
import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/admin/esSeriesSetup';
const subdomainTypeUrl = base_url+'api/admin/esSubdomainType';
const venueUrl = base_url+'api/admin/esVenue';

export const getData = async (req) => {
  const response = await api.get(path,{params: {
    sub_domain: req?.sub_domain|| "",   
  }});
  return response.data.data;
};

export const getsubdomainType = async () => {
  const response = await api.get(subdomainTypeUrl);
  return response.data.data;
};

export const getvenue = async () => {
  const response = await api.get(venueUrl);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};
